import React, { useEffect, useState } from 'react'
import {
  Card, CardBody, CardHeader,
  Button, CustomInput, Input, Label, FormGroup
} from 'reactstrap'
import _ from 'lodash'

import ImageField from 'components/ImageField/index'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import MultilingualInput from 'components/MultiLangInput/v2'
import Lang from 'Lang/General'
import HOC from './action'
import { DefaultFormValue } from './assets'

function Brand(props) {

  const [formData, setFormData] = useState(DefaultFormValue)

  useEffect(() => {
    if (!_.isEmpty(props.selectedPortalUsers)) {
      props.getBrandsListing(props.selectedPortalUsers.id)
    }
  }, [props.selectedPortalUsers])

  useEffect(() => {
    if (!_.isEmpty(props.selectedBrand)) {
      setFormData(props.selectedBrand)
    } else {
      setFormData(DefaultFormValue)
    }
  }, [props.selectedBrand])

  useEffect(() => {
    if (props.brandListing?.[0]) {
      props.onChangeBrandHOC('selectedBrand', props.brandListing?.[0])
    }
  }, [props.brandListing])

  return (
    <>
      <div className="d-flex flex-row flex-wrap align-items-center mt-4">
        {
          props.selectedPortalUsers.role === 'EXHIBITOR' && (
            <CustomInput
              className='mr-2 mb-3'
              id='brand-is-newcomer'
              type='checkbox'
              checked={ formData.is_newcomer }
              label={ Lang[ 'IS_NEWCOMER' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
              onChange={ e => setFormData({ ...formData, is_newcomer: e.target.checked }) }
            />
          )
        }
        <Button
          className={'ml-auto mr-2 mb-3'}
          color={'primary'}
          onClick={() => {
            props.onChangeBrandHOC('selectedBrand', '')
            setFormData(DefaultFormValue)
          }}
        >
          {Lang['CREATE_BRANDS'][props.data.languageReducer.userSettings.admin_panel_language]}
        </Button>
        <Input
          className='mb-3'
          value={props.selectedBrand?.id || null}
          type={'select'}
          style={{ maxWidth: 150 }}
          placeholder={'Select Brand'}
          onChange={e => props.onChangeBrandHOC('selectedBrand', _.find(props.brandListing, { id: +e.target.value }))}
        >
          <option value={''}>
            {''}
          </option>
          {
            props.brandListing.map(brandOption => (
              <option key={brandOption.id} value={brandOption.id}>
                {brandOption.name}
              </option>
            ))
          }
        </Input>
      </div>
      <Card>
        <CardHeader>
          {
            Lang[!props.selectedBrand ? 'CREATE_BRANDS' : 'UPDATE_BRANDS'][props.data.languageReducer.userSettings.admin_panel_language]
          }
        </CardHeader>
        <CardBody>
          <FormGroup>
            <Label>
              {Lang['LOGO'][props.data.languageReducer.userSettings.admin_panel_language]}
              <span className="text-danger">{` *`}</span>
            </Label>
            <ImageField
              onChange={val => setFormData({
                ...formData,
                logo: val
              })}
              fileValue={formData?.logo?.url}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['IMAGE'][props.data.languageReducer.userSettings.admin_panel_language]}
              {` 1`}
            </Label>
            <ImageField
              onChange={val => setFormData({
                ...formData,
                image_1: val
              })}
              fileValue={formData?.image_1?.url}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['IMAGE'][props.data.languageReducer.userSettings.admin_panel_language]}
              {` 2`}
            </Label>
            <ImageField
              onChange={val => setFormData({
                ...formData,
                image_2: val
              })}
              fileValue={formData?.image_2?.url}
            />
          </FormGroup>
        </CardBody>
      </Card>
      <Card className={'mt-3 mb-2'}>
        <CardBody>
          <h5>{Lang['TEASER'][props.data.languageReducer.userSettings.admin_panel_language]}</h5>
          <hr />
          <FormGroup>
            <Label>
              {Lang['BRAND_NAME'][props.data.languageReducer.userSettings.admin_panel_language]}
              <span className="text-danger">{` *`}</span>
            </Label>
            <Input
              value={formData.name}
              onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })}
            />
          </FormGroup>
          {
            props.selectedBrand && (
              <FormGroup>
                <Label>
                  {Lang['SLUG'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <Input
                  value={formData.slugs}
                  onChange={e => setFormData({
                    ...formData,
                    slugs: e.target.value
                  })}
                />
              </FormGroup>
            )
          }
          <MultilingualInput
            label={Lang['HEADLINE'][props.data.languageReducer.userSettings.admin_panel_language]}
            selectedLanguage={props.data.languageReducer.userSettings.admin_panel_language}
            value={formData.headline}
            valueName='headline'
            parent={formData}
            onChangeValue={(parentName, formDataValue) => setFormData(formDataValue)}
          />
          <MultilingualInput
            isTextArea
            label={Lang['SHORT_DESC'][props.data.languageReducer.userSettings.admin_panel_language]}
            selectedLanguage={props.data.languageReducer.userSettings.admin_panel_language}
            value={formData.short_description}
            valueName='short_description'
            parent={formData}
            onChangeValue={(parentName, formDataValue) => setFormData(formDataValue)}
          />
          <FormGroup>
            <Label>
              {Lang['WEBSITE_ADDRESS'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.website_address}
              onChange={e => setFormData({
                ...formData,
                website_address: e.target.value
              })}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['FACEBOOK'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.facebook_link}
              onChange={e => setFormData({
                ...formData,
                facebook_link: e.target.value
              })}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['INSTRAGRAM'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.instagram_link}
              onChange={e => setFormData({
                ...formData,
                instagram_link: e.target.value
              })}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['LINKEDIN'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.linkedin_link}
              onChange={e => setFormData({
                ...formData,
                linkedin_link: e.target.value
              })}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['YOUTUBE'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={formData.youtube_link}
              onChange={e => setFormData({
                ...formData,
                youtube_link: e.target.value
              })}
            />
          </FormGroup>
          <small className="d-block mb-3">
            {Lang['FEX_ALERT_MSG'][props.data.languageReducer.userSettings.admin_panel_language]}
          </small>
          <div className="d-flex">
            <Button
              color={'primary'}
              className={'ml-auto'}
              onClick={() => {
                let temp = _.cloneDeep(formData)

                temp.image_1 = props.selectedBrand && formData.image_1.url === props.selectedBrand.image_1.url ? null : {
                  raw: formData.image_1.raw,
                  filename: formData.image_1.filename
                }

                temp.image_2 = props.selectedBrand && formData.image_2.url === props.selectedBrand.image_2.url ? null : {
                  raw: formData.image_2.raw,
                  filename: formData.image_2.filename
                }

                temp.logo = props.selectedBrand && formData.logo.url === props.selectedBrand.logo.url ? null : {
                  raw: formData.logo.raw,
                  filename: formData.logo.filename
                }

                !props.selectedBrand ? props.createBrand({
                  ...temp,
                  user_id: props.selectedPortalUsers.id
                }) : props.updateBrand({
                  ...temp,
                  user_id: props.selectedPortalUsers.id
                })
              }}
            >
              {Lang['SAVE'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Button>
          </div>
        </CardBody>
      </Card>
      {
        props.onLoadBrand && <LoadingOverlay />
      }
    </>
  )
}

export default HOC(Brand)